export const defaultProactiveChatPaneCloseButtonStyles = {
  color: "white",
  fontSize: "12px"
};